import styled, { css } from 'styled-components'

import { ASC } from './constants'

import { base } from '../../mixins'
import { PB97T, PB30T, PB, WHITE } from '../../colors'
import { Button } from '../../buttons/button'
import { SortIcon as SIcon } from '../../icons/sort'

const headerElement = document.getElementById('h2-header')
const cellStyles = css`
  text-align: left;
  padding: 0 8px 24px 8px;
  width: ${props => props.size};
`
const SortIcon = styled(SIcon)`
  position: absolute;
  margin-left: 10px;
  transform: rotate(${props => (props.direction === ASC ? '180deg' : '0deg')});
  cursor: pointer;

  > svg {
    width: 16px;
    height: 16px;
  }
`
const Container = styled.div`
  ${base};
  padding-bottom: 24px;
`
const Wrapper = styled.div`
  background-color: white;
  padding: ${({ fullWidth }) => (fullWidth ? '0' : '32px')};
  padding-bottom: 0;
  min-height: ${props => (props.mode === 'search' ? '250px' : 'auto')};
  border-left: ${({ fullWidth }) => (fullWidth ? 'none' : `solid 10px ${PB97T}`)};
  border-right: ${({ fullWidth }) => (fullWidth ? 'none' : `solid 10px ${PB97T}`)};
`
const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
`
const Head = styled.thead`
  border-bottom: 10px solid ${WHITE};
`
const Header = styled.th`
  ${cellStyles};
  background-color: ${PB97T};
  position: sticky;
  font-size: 16px;
  color: ${PB};
  top: ${headerElement ? '52px' : '0'};
  z-index: 20;
  padding: 24px 8px;
  border-radius: 5px;
  text-align: ${({ labelAlign }) => labelAlign};
`
const sortStyles = css`
  &:hover {
    cursor: pointer;
    ${SortIcon} {
      display: inline-flex;
    }
  }
`
const SortableHeader = styled(Header)`
  ${sortStyles}

  ${SortIcon} {
    display: none;
  }
`
const SortedHeader = styled(Header)`
  ${sortStyles}
  font-weight: bold;
`
const Row = styled.tr`
  background: linear-gradient(to right, ${PB97T} 50%, ${WHITE} 50%);
  background-size: 200% 100%;
  background-position: ${({ selected }) => (selected ? 'left bottom' : 'right bottom')};
  &:hover {
    cursor: ${props => (typeof props.onClick === 'function' ? 'pointer' : 'auto')};
    background-position: left bottom;
    transition: all 0.3s ease;
  }
`
const DisabledRow = styled(Row)`
  &:hover {
    cursor: auto;
  }

  td {
    color: ${PB30T};
  }
`
const Body = styled.tbody`
  tr {
    :first-child {
      td {
        border-top: none;
      }
    }
    :not(:last-of-type) {
      border-bottom: solid 1px ${PB97T};
    }
    :last-of-type {
      border-bottom: solid 10px ${WHITE};
    }
  }
`
const Cell = styled.td`
  ${cellStyles}
  position: relative;
  padding-top: 24px;
  font-size: 16px;
  line-height: 16px;
  color: ${PB};
`
const DataCell = styled(Cell)`
  max-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
const SortedCell = styled(DataCell)`
  font-weight: bold;
`
const MenuCell = styled(Cell)`
  cursor: auto;
`
const Controls = styled.div`
  display: flex;
  margin: 0 0 16px 0;
`
const CheckboxWrapper = styled.div`
  position: absolute;
  top: 22px;
`
const ActionButton = styled(Button)`
  white-space: nowrap;
  margin-left: 24px;
`

export {
  Container,
  Wrapper,
  Table,
  Head,
  Header,
  Body,
  Row,
  DisabledRow,
  Cell,
  DataCell,
  MenuCell,
  SortedCell,
  SortableHeader,
  SortedHeader,
  SortIcon,
  Controls,
  CheckboxWrapper,
  ActionButton
}
